import React from 'react';
import { Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import GridCheckBox from '../../../../Components/Ui/GridCheckBox/GridCheckBox';
import CustomHeader from '../../../../Components/AgGrid/CustomHeader';

export const getColumnDefs1 = (props) => {
  const plTypeList = props.plTypeList || [];

  return [
    {
      headerCheckboxSelection: true,
      field: 'no',
      headerName: 'NO',
      maxWidth: 100,
      cellStyle: {
        textAlign: 'right',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      editable: false,
      cellClass: 'delete-action-cell',
      cellRenderer: (params) => {
        return (
          <GridCheckBox
            params={params}
            DeleteNewRow={props.DeleteNewRow1}
            RestoreRow={props.RestoreRow1}
            gridRef={props.gridRef1}
            rowData={props.rowData1}
            selectedRowNosRef={props.selectedRowNosRef1}
            lastCheckedIndexRef={props.lastCheckedIndexRef1}
            handleRowSelection={props.handleRowSelection1}
          />
        );
      },
    },
    {
      field: 'CO_CD',
      headerName: '회사 코드',
      headerComponent: CustomHeader,
      headerComponentParams: {
        required: true,
      },
      minWidth: 150,
      editable: false,
    },
    {
      field: 'CO_NM',
      headerName: '회사 명',
      headerComponent: CustomHeader,
      headerComponentParams: {
        required: true,
      },
      minWidth: 150,
      flex: 1,
      editable: false,
      hide: false,
      cellStyle: {
        backgroundColor: '#f5f5f5',
        color: '#555',
        fontStyle: 'italic',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'not-allowed',
      },
      cellRenderer: (e) => (
        <Tooltip
          title="회사 선택 후, 추가 시 자동 입력됩니다."
          arrow
          enterDelay={300}
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: '0.9rem',
                backgroundColor: '#444',
                color: '#fff',
                padding: '8px 12px',
              },
            },
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <InfoOutlinedIcon fontSize="small" sx={{ color: '#888' }} />
            <span>{e.value || ''}</span>
          </div>
        </Tooltip>
      ),
    },
    {
      field: 'PL_TYPE',
      headerName: '구분',
      headerComponent: CustomHeader,
      headerComponentParams: {
        required: true,
      },
      minWidth: 160,
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: plTypeList.map((item) => item.value),
      },
      valueFormatter: (params) => {
        const match = plTypeList.find((item) => item.value === params.value);
        return match ? match.name : params.value;
      },
      flex: 1,
      editable: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
  ];
};
